module.exports = {"130581001":"凤岗街道","130581002":"南杜街道","130581003":"北胡街道","130581004":"西丁街道","130581100":"苏村镇","130581101":"大高村镇","130581102":"垂杨镇","130581103":"明化镇","130581104":"段芦头镇","130581105":"紫冢镇","130581200":"大村乡","130581201":"南便村乡","130581202":"大屯乡","130581203":"王道寨乡","130581204":"薛吴村乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130581.json
// module id = 135
// module chunks = 0